/**
 * Authorization Roles
 */
const authRoles = {
	admin: ['Admin'],
	userProfile: ['UserProfile'],
	userAccount: ['UserAccount'],
	userRole: ['UserRole'],
	onlyGuest: []
};

export default authRoles;
